import { render, staticRenderFns } from "./AbsenceTab.vue?vue&type=template&id=90b84904&"
import script from "./AbsenceTab.vue?vue&type=script&lang=js&"
export * from "./AbsenceTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90b84904')) {
      api.createRecord('90b84904', component.options)
    } else {
      api.reload('90b84904', component.options)
    }
    module.hot.accept("./AbsenceTab.vue?vue&type=template&id=90b84904&", function () {
      api.rerender('90b84904', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/employee/permission/absences/AbsenceTab.vue"
export default component.exports